var map = {
	"./dark/CodePen.png": 509,
	"./dark/GitHub.png": 192,
	"./dark/LinkedIn.png": 922,
	"./dark/WhatsApp.png": 537,
	"./light/CodePen.png": 176,
	"./light/GitHub.png": 874,
	"./light/LinkedIn.png": 409,
	"./light/WhatsApp.png": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;